module.exports = __webpack_public_path__ + "static/media/LogoAsl.a5e7a704.svg";